import { AbstractGridListingFilter, type IGridListingFilterValue } from '../../listing-grid-v1/grid.listing.filter';

export class ComplexGridListingFilter extends AbstractGridListingFilter {
    public values() {
        const result = [
            {
                name: 'textValue',
                value: this.value('textValue')
            },
            {
                name: 'textFields',
                value: this.value('textValue') && this.value('textFields')
            }
        ];
        return result;
    }

    value(variable) {
        let ret = undefined;
        if (variable === 'textValue') {
            ret = this.scopeVariable.value;
        } else if (variable === 'textFields') {
            ret = this.scopeVariable.fields;
        }
        return ret;
    }

    title(name, value) {
        return `${value}`;
    }

    public descriptions() {
        return (values: IGridListingFilterValue[]) => {
            const titles: string[] = [];
            values.forEach(item => {
                if (item.value && item.name !== 'textFields') {
                    titles.push(this.title(item.name, this.value(item.name)));
                }
            });

            return {
                quick: this.quick,
                empty: this.noBottom,
                titles: titles
            };
        };
    }

    public isEmpty() {
        let empty = true;
        this.values().forEach(item => {
            if (item.value && item.name !== 'textFields') {
                empty = false;
            }
        });
        return empty;
    }

    public clear() {
        this.scopeVariable.value = '';
    }
}
